// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// https://wapi-ceroideas-proxy-development-container-gvfdcmhnc2bpcxbq.francecentral-01.azurewebsites.net/drivers/all - development
// https://wapi-ceroideas-proxy-container-gyecfyf3gahsa3ej.francecentral-01.azurewebsites.net/clients - production

export const environment = {
  production: false,
  url: 'https://wapi-ceroideas-proxy-development-container-gvfdcmhnc2bpcxbq.francecentral-01.azurewebsites.net',
  products_url: 'https://products-api.development.cafler.com',
  trackingUrl: 'https://tracking-api.development.cafler.com/api',

  // Configuración de autenticación Azure AD / MSAL
  auth: {
    clientId: '1649588b-cd93-42f9-bbb4-d8db8ce706d8',
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: '/',
    scopes: ['api://cafler-logistics-api/Test.TestRead'],
    cacheLocation: 'localStorage' as 'localStorage' | 'sessionStorage',
    storeAuthStateInCookie: true,
    tokenExpirationHours: 48,
    tokenReuseMinutes: 10,
    silentRenewalTimeoutMs: 5000,
  },

  // Flags de funcionalidad.
  // expensesMock: sirve el módulo de Gastos desde datos en memoria en lugar de la
  // API de Tracking. Se deja en `false` desde la integración; ponerlo a `true`
  // permite trabajar en la pantalla sin backend.
  features: {
    expensesMock: false,
  },

  // url: 'http://localhost:3000',

  // azure: {
  //   clientId: '1649588b-cd93-42f9-bbb4-d8db8ce706d8',
  //   authority: 'https://login.microsoftonline.com/',
  //   redirectUri: 'http://localhost:4200',
  //   // clientSecret: 'TU_CLIENT_SECRET',
  //   tenantId: 'common',
  //   postLogoutRedirectUri: ' http://localhost:4200/login',
  // },
};

// https://wapi-ceroideas-proxy-container-gyecfyf3gahsa3ej.francecentral-01.azurewebsites.net/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
